<template>
  <div class="view-container">
    <ScrollController #default="scrollProps">
      <transition name="fade" mode="out-in">
        <slot v-bind="scrollProps" />
      </transition>
    </ScrollController>
    <ViewRotate class="view-container__rotate" />
  </div>
</template>

<script>
import ScrollController from '../ScrollingController';
import ViewRotate from '../ViewRotate';

export default {
  name: 'ViewContainer',

  components: {
    ScrollController,
    ViewRotate,
  },
};
</script>

<style lang="scss" scoped>
.view-container {
  height: 100%;
}

.view-container__rotate {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
